import React from 'react';
import { View } from '../../types/types';
import { handleActionError } from '../../utils/engineering-tools';
import { PAGE_SIZE } from '../../../components/bearing-search/api/api';
import { BearingInfo, BearingKey, TimkenSortDirection } from '../../../components/bearing-search/types/types';

export type BearingSearchState = {
	comparedData: BearingInfo[];
	currentPage: number;
	totalPages: number;
	pageSize: number;
	isRefining: boolean;
	sortExpression?: BearingKey;
	sortDirection?: TimkenSortDirection;
	view: View;
};

export const initialSearchState: BearingSearchState = {
	comparedData: [],
	currentPage: 1,
	totalPages: 0,
	pageSize: PAGE_SIZE,
	isRefining: false,
	sortDirection: "desc",
	sortExpression: "availability",
	view: View.LIST,
};

export type BearingSearchAction =
	| { type: 'update_total_records'; payload: number }
	| { type: 'change_page'; payload: number }
	| { type: 'update_compare'; payload: BearingInfo }
	| { type: 'sort_by'; payload: string | undefined }
	| { type: 'change_view'; payload: View }
	| { type: 'reset'; payload?: BearingSearchState };

const paginate = ( totalRecords: number, size: number ): number => {
	return totalRecords === 0 ? 0 : Math.ceil( totalRecords / size );
};

const bearingSearchReducer: React.Reducer<
	BearingSearchState,
	BearingSearchAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'update_total_records': {
			const totalPages = paginate( action.payload, state.pageSize );

			return {
				...state,
				totalPages,
				isRefining: false,
			};
		}
		case 'update_compare': {
			const bearing = action.payload;
			const comparedData = [ ...state.comparedData ];

			const targetId = comparedData.findIndex( ( item ) => item.marketPlaceDescription === bearing.marketPlaceDescription );

			if ( targetId >= 0 ) {
				// remove
				comparedData.splice( targetId, 1 );
			} else {
				// add
				comparedData.push( bearing );
			}

			return {
				...state,
				comparedData,
			};
		}
		case 'change_page': {
			const currentPage = action.payload;

			return {
				...state,
				isRefining: true,
				currentPage,
			};
		}
		case 'sort_by': {
			const { sortDirection, sortKey } = state;
			const newSortKey = action.payload;

			if ( ! newSortKey ) {
				// Unsort
				return {
					...state,
					sortKey: undefined,
					sortDirection: undefined,
				};
			}

			const newSortDirection = sortKey !== newSortKey || sortDirection !== 'asc' ? 'asc' : 'desc';

			return {
				...state,
				isRefining: true,
				sortKey: newSortKey as BearingKey,
				sortDirection: newSortDirection,
			};
		}
		case 'change_view': {
			return {
				...state,
				view: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialSearchState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default bearingSearchReducer;
